const ROUTES = {
  HOME: '/',
  PRODUCT_DETAIL: '/products/:id',
  ADD_PRODUCT: '/add-product',
  EDIT_PRODUCT: '/edit-product/:id',
  CART: '/cart'
}

export { ROUTES }
